import './BetbookCommentBody.less';

import clsx from 'clsx';
import { Map } from 'immutable';
import React, { memo } from 'react';

import BetbookCommentEditor from '@/betbook/components/betbook-comment-editor/BetbookCommentEditor';
import * as CommentTicket from '@/forum/commentTicket';
import * as CommentAnalyse from '@/forum/commentAnalyse';
import PopupNg from '@/ui/PopupNg';

import ChatTicketDetail from '@/mytickets/detail/views/Slider/ChatTicketDetail';
import ChatAnalyseDetail from '@/mytickets/detail/views/Slider/ChatAnalyseDetail';
import { navigate } from '@/routing';
import { COMMUNITY_ANALYSIS_DETAIL } from '@/routing/routes';
import { stripAnalyses } from '@/forum/commentAnalyse';
import { stripTickets } from '@/forum/commentTicket';

const CommentText = memo(({ text }) => {
    const commentText = stripTickets(stripAnalyses(text));
    const commentTicketAdd = Map(CommentTicket.ticketsFromMessage(text, true));
    const commentAnalyseAdd = Map(CommentAnalyse.analysesFromMessage(text));

    return (
        <>
            <p className="comment-text">{commentText}</p>
            <CommentItems commentTickets={commentTicketAdd} commentAnalysis={commentAnalyseAdd} />
        </>
    );
});

function CommentItems({ commentTickets, commentAnalysis }) {
    if (!commentTickets.size && !commentAnalysis.size) {
        return null;
    }

    function openDetailTicketDialog(hash) {
        PopupNg.dispatcher.open('betbook/ticketDetailPopup', { hash });
    }

    function openDetailAnalyseDialog(item) {
        navigate(COMMUNITY_ANALYSIS_DETAIL, {
            postId: item.id,
            postUrlSuffix: '_'
        });
    }

    return (
        <div className="chat-items chat-selected-tickets-section">
            {commentTickets.valueSeq().map(ticket => (
                <div className="chat-item" key={ticket.hash}>
                    <ChatTicketDetail ticket={ticket} onClick={() => openDetailTicketDialog(ticket.hash)} />
                </div>
            ))}
            {commentAnalysis.valueSeq().map(analysis => (
                <div className="chat-item" key={analysis.id}>
                    <ChatAnalyseDetail analysis={analysis} onClick={() => openDetailAnalyseDialog(analysis)} />
                </div>
            ))}
        </div>
    );
}

function BetbookCommentBody({ className, editingCommentId, invalid, text }) {
    return (
        <div className={clsx('betbook-comment-body', className, { invalid })}>
            {invalid ? (
                text
            ) : editingCommentId ? (
                <BetbookCommentEditor commentId={editingCommentId} initialText={text} />
            ) : (
                <CommentText text={text} />
            )}
        </div>
    );
}

export default BetbookCommentBody;
